import React, {useEffect, useState} from 'react';
import {Button, Grid, Header, Icon, Input, Label, Pagination, Segment, Select, Table} from 'semantic-ui-react';
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import {toast} from "react-toastify";
import {SessionUser} from "../../../models/session-user";
import SessionStorage from "../../../store/session";
import {useBlockUI} from "../../../shared/services/block-ui-service";
import {UnidadesDeNegocio} from "../../../models/unidades-de-negocio";
import {ToasterConfig} from "../../../config/ToasterConfig";
import {UnidadeDeNegociosFilter} from "../../../filters/unidade-de-negocios-filter";
import useBusinessUnitService from "../../../services/backoffice/hooks/useBusinessUnitService";
import useFormatDateUtils from "../../../shared/utils/hooks/useFormatDateUtils";
import useClientService from "../../../services/backoffice/hooks/useClientService";
import {ShortDto} from "../../../models/short-dto";
import TooltipInfo from "../../../components/tooltip/tooltip";

const BusinessUnitListPage = () => {
    const [businessUnits, setBusinessUnits] = useState<UnidadesDeNegocio[]>([]);
    const [error, setError] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const [filter, setFilter] = useState<UnidadeDeNegociosFilter>()
    const [totalPages, setTotalPages] = useState<number>()
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [clients, setClients] = useState<ShortDto[]>([]);
    const blockUI = useBlockUI();
    const {getAllClientsShortDto} = useClientService()
    const {deleteUnit, getUnits, activeUnit, deactiveUnit} = useBusinessUnitService();
    const {formatToBrazilianShortDate} = useFormatDateUtils();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user)
        }

        updateSessionUser()
    }, [])
    const [showFilters, setShowFilters] = useState(false);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    useEffect(() => {
        listBusinessUnits();
    }, []);


    async function listBusinessUnits() {
        setLoading(true)
        const response = await getUnits(filter);
        setLoading(false)
        setTotalPages(response.totalPages);
        setBusinessUnits(response.itens);
    }

    useEffect(() => {
        function ListClients() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
                .catch(error => {
                })
        }

        ListClients()
    }, [])

    const toggleActivationBusinessUnit = async (businessUnit: UnidadesDeNegocio, activate?: boolean) => {
        try {
            const result = window.confirm(`Tem certeza que deseja ${businessUnit.isActive ? 'desativar' : 'ativar'} a Unidade de Negócio ${businessUnit.name}?`);
            if (!result) return
            setLoading(true);
            if (businessUnit) {
                const result = !businessUnit.isActive ? await activeUnit(businessUnit.id) : await deactiveUnit(businessUnit.id);
                if (!!result) {
                    toast.success(`A Unidade de Negócio foi ${businessUnit.isActive ? 'desativada' : 'ativada'} com sucesso`, ToasterConfig.success);
                    listBusinessUnits()
                }
            }
            setLoading(false);
        } catch (error: any) {
            toast.warn(`Falha ao ${businessUnit.isActive ? 'desativar' : 'ativar'} Unidade de Negócio`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    };

    async function deleteBusinessUnit(businessUnit: UnidadesDeNegocio) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja apagar a unidade ${businessUnit.name}?`);

            if (confirm) {
                if (businessUnit) {
                    await deleteUnit(businessUnit.id);
                    toast.success('Unidade de negócio deletada com sucesso', ToasterConfig.success);
                    listBusinessUnits()
                }
                setLoading(false);
            }
        } catch (error: any) {
            toast.warn(`Falha ao deletar unidade de negócio`, ToasterConfig.error);
            setLoading(false);
            setError(error.message);
        }
    }

    return (
        <div>
            <Header as="h3" textAlign="center" color={'green'}>
                Unidades de Negócio
            </Header>
            <Table.Row>
                <Table.HeaderCell>
                    {sessionUser?.userData?.profile == 'Admin' &&
                        <Button color="green"
                                onClick={() => navigate('/backoffice/business-units/create/')}>

                            <Icon name='plus'/> Novo
                        </Button>}
                </Table.HeaderCell>
                <Table.HeaderCell colSpan="4">
                    <Button onClick={toggleFilters} color={"green"}>
                        <Icon name={showFilters ? 'hide' : 'unhide'}/>
                        {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                    </Button>
                </Table.HeaderCell>
            </Table.Row>

            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={7}>
                                <label htmlFor="businessUnitName">Nome da Unidade de Negócios</label>
                                <Input
                                    fluid
                                    id="businessUnitName"
                                    icon="search"
                                    type="text"
                                    placeholder="Nome da Unidade de Negócios"
                                    value={filter?.name ?? ''}
                                    onChange={event =>
                                        setFilter({...filter, name: event.target?.value})
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={7}>
                                <label htmlFor="client">Cliente da Unidade de Negócio</label>
                                <Select clearable
                                        placeholder="Cliente da Unidade de Negócio"
                                        fluid
                                        search
                                        selection
                                        options={clients}
                                        value={filter?.clientId ?? ''}
                                        onChange={(event, data) =>
                                            //@ts-ignore
                                            setFilter({...filter, clientId: data.value})
                                        }
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={listBusinessUnits}>Buscar</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}


            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell>Cliente</Table.HeaderCell>
                        <Table.HeaderCell>Criado em</Table.HeaderCell>
                        <Table.HeaderCell>Ativo</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                {(sessionUser?.userData?.profile == 'Admin' || 'Manager') &&
                    <Table.Body>
                        {businessUnits?.map((businessUnit) => (
                            <Table.Row key={businessUnit.id}>
                                <Table.Cell>
                                    <Button.Group>
                                        <TooltipInfo
                                            content="Editar unidade de negócio"
                                            trigger={
                                                <Button
                                                    color="blue"
                                                    onClick={() => {
                                                        setLoading(true);
                                                        navigate('/backoffice/business-units/edit/' + businessUnit.id);
                                                    }}
                                                    icon="edit"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content="Excluir unidade de negócio"
                                            trigger={
                                                <Button
                                                    color="red"
                                                    onClick={() => deleteBusinessUnit(businessUnit)}
                                                    icon="trash"
                                                />
                                            }
                                        />

                                        <TooltipInfo
                                            content={businessUnit.isActive ? "Desativar unidade de negócio" : "Ativar unidade de negócio"}
                                            trigger={
                                                <Button
                                                    color={businessUnit.isActive ? 'red' : 'green'}
                                                    onClick={() => toggleActivationBusinessUnit(businessUnit)}
                                                    icon={businessUnit.isActive ? 'power off' : 'power'}
                                                />
                                            }
                                        />
                                    </Button.Group>

                                </Table.Cell>
                                <Table.Cell>{`${businessUnit.name}`}</Table.Cell>
                                <Table.Cell>{`${businessUnit?.clientName}`}</Table.Cell>
                                <Table.Cell>{moment(businessUnit.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>
                                <Table.Cell>
                                    <Label key={businessUnit.id}
                                           color={!businessUnit.isActive ? 'red' : 'green'}>{businessUnit.isActive ? 'Sim' : 'Não'}</Label>
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>}
            </Table>
            <Pagination totalPages={totalPages ?? 0}
                        defaultActivePage={filter?.Page ?? 1}
                        onPageChange={(e, {activePage}) => {
                            setFilter({...filter, Page: activePage as number})
                        }
                        }>
            </Pagination>
        </div>
    );
};

export default BusinessUnitListPage;
